import React from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

import { withStyles } from "tss-react/mui";
import JamezzFormStyles from "../../views/JamezzForm/JamezzFormStyles";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import SubsInvoiceGeneral from "./Tabs/SubsInvoiceGeneral";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../utils/formatting";

const endPoint = "core/subsInvoice";

function SubsInvoiceForm() {
  return (
    <AuthProvider prefix={"subsInvoices"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.description);
        }}
        endPoint={endPoint}
        mode={"onSubmit"}
        pageTitle={getTranslation("subDebtors.form.pageTitle", "Invoice")}
        revalidateMode={"onChange"}
        tabs={[
          {
            right: "general",
            tabButton: <TranslationWrapper tDefault={"General"} tKey={"subsInvoices.form.tabs.general"} />,
            tabContent: <SubsInvoiceGeneral />,
          },
        ]}
      />
    </AuthProvider>
  );
}

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SubsInvoiceForm, JamezzFormStyles));
